import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSync = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing" */ '@atlassian/jira-eoc-alert-issue-syncing'
	).then((module) => module.AlertIssueSync),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSyncCreate = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync-create", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing-create" */ '@atlassian/jira-eoc-alert-issue-syncing'
	).then((module) => module.AlertIssueSyncCreate),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertIssueSyncDetail = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-alert-issue-sync-detail", jiraSpaEntry: "async-jira-eoc-alert-issue-syncing-detail" */ '@atlassian/jira-eoc-alert-issue-syncing'
	).then((module) => module.AlertIssueSyncDetail),
);
